import { useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import "@fontsource/poppins";

const projectData = [
  {
    id: 1,
    title: "Hotel D' Continental",
    image: "/pic1.jpg",
    description:
      "Pembangunan hotel modern yang mengutamakan kenyamanan dan efisiensi energi dengan sistem struktur kuat dan desain arsitektur elegan.",
  },
  {
    id: 2,
    title: "RSUD Cipayung Tipe D",
    image: "/Picture7.png",
    description:
      "Rumah sakit dengan desain struktur fungsional dan sistem utilitas efisien untuk mendukung layanan kesehatan masyarakat.",
  },
  {
    id: 3,
    title: "Kantor Pusat BATAN",
    image: "/Picture2.jpg",
    description:
      "Gedung perkantoran pusat lembaga penelitian dengan struktur baja dan beton bertulang untuk ketahanan dan stabilitas tinggi.",
  },
  {
    id: 4,
    title: "Rehabilitasi Masjid Raya Baiturrahman",
    image: "/Picture4.jpg",
    description:
      "Proyek renovasi besar yang mempertahankan nilai arsitektur klasik sambil memperkuat struktur utama masjid agar lebih tahan lama.",
  },
  {
    id: 5,
    title: "Kantor Pusat BPD Jambi",
    image: "/up2.png",
    description:
      "Bangunan kantor pusat perbankan dengan desain modern minimalis dan sistem struktur hemat energi.",
  },
  {
    id: 6,
    title: "Gudang Moulding Rucika",
    image: "/up1.png",
    description:
      "Gudang industri dengan desain struktur baja ringan dan tata ruang efisien untuk mendukung aktivitas produksi dan distribusi.",
  },
];

export default function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerSlide = 3;

  const nextSlide = () => {
    setStartIndex((prev) =>
      prev + itemsPerSlide >= projectData.length ? 0 : prev + itemsPerSlide
    );
  };

  const prevSlide = () => {
    setStartIndex((prev) =>
      prev - itemsPerSlide < 0
        ? Math.max(projectData.length - itemsPerSlide, 0)
        : prev - itemsPerSlide
    );
  };

  const nextProject = () => {
    setSelectedProject((prev) =>
      prev === projectData.length - 1 ? 0 : prev + 1
    );
  };

  const prevProject = () => {
    setSelectedProject((prev) =>
      prev === 0 ? projectData.length - 1 : prev - 1
    );
  };

  return (
    <section
      id="projects"
      className="w-full bg-[#2C3E50] text-white font-[Poppins] flex flex-col items-start justify-start py-10 sm:py-14 px-[4vw]"
    >
      {/* === TITLE === */}
      <div className="w-full flex justify-start mb-10 sm:mb-16">
        <h2 className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight drop-shadow-lg">
          Projects
        </h2>
      </div>

      {/* === SLIDER === */}
      <div className="relative w-full overflow-hidden">
        <div
          className="flex transition-transform duration-700 ease-in-out gap-4 sm:gap-6 md:gap-8"
          style={{
            transform: `translateX(-${
              (startIndex / projectData.length) * 100
            }%)`,
            width: `${(projectData.length * 100) / itemsPerSlide}%`,
          }}
        >
          {projectData.map((project, index) => (
            <div
              key={project.id}
              onClick={() => setSelectedProject(index)}
              className="flex-1 cursor-pointer hover:scale-[1.02] transition-transform duration-500"
            >
              <div className="relative h-[150px] sm:h-[210px] md:h-[300px] lg:h-[350px] overflow-hidden rounded-xl shadow-lg">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="mt-3 sm:mt-4 text-xs sm:text-base md:text-xl font-semibold text-center leading-snug">
                {project.title}
              </h3>
            </div>
          ))}
        </div>

        {/* === NAV BUTTONS === */}
        <div className="absolute inset-0 flex items-center justify-between px-2 sm:px-6 md:px-8 z-20 pointer-events-none">
          <button
            onClick={prevSlide}
            className="bg-black/60 hover:bg-black/80 text-white p-2 sm:p-3 rounded-full shadow-lg transition pointer-events-auto"
            style={{
              transform: "translateY(-50%)",
              position: "absolute",
              top: "50%",
              left: "1px",
            }}
          >
            <ChevronLeft size={22} className="sm:w-6 sm:h-6 md:w-7 md:h-7" />
          </button>

          <button
            onClick={nextSlide}
            className="bg-black/60 hover:bg-black/80 text-white p-2 sm:p-3 rounded-full shadow-lg transition pointer-events-auto"
            style={{
              transform: "translateY(-50%)",
              position: "absolute",
              top: "50%",
              right: "14px",
            }}
          >
            <ChevronRight size={22} className="sm:w-6 sm:h-6 md:w-7 md:h-7" />
          </button>
        </div>
      </div>

      {/* === POPUP === */}
      {selectedProject !== null && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-2">
<div
  className="
    relative bg-[#2C3E50]
    w-[95%] sm:w-[90%] md:w-[80%] max-w-[900px]
    h-auto sm:h-[65vh] md:h-[70vh]
    rounded-xl flex flex-row
    items-center justify-between
    shadow-2xl overflow-hidden
    p-4 sm:p-6
  "
>



            {/* CLOSE BUTTON */}
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-3 right-3 text-white hover:text-gray-300 transition"
            >
              <X size={24} className="sm:w-7 sm:h-7 md:w-8 md:h-8" />
            </button>

            {/* LEFT IMAGE */}
            <div className="relative w-full sm:w-[55%] h-[38%] sm:h-full flex items-center justify-center bg-[#1F2E3B]">
              <img
                src={projectData[selectedProject].image}
                alt={projectData[selectedProject].title}
                className="w-[80%] sm:w-[88%] h-[78%] sm:h-[86%] object-contain rounded-lg"
              />

              {/* PANAH */}
              <button
                onClick={prevProject}
                className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 text-white hover:scale-110 transition-transform duration-200"
              >
                <ChevronLeft size={28} className="sm:w-10 sm:h-10 md:w-12 md:h-12" />
              </button>
              <button
                onClick={nextProject}
                className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 text-white hover:scale-110 transition-transform duration-200"
              >
                <ChevronRight size={28} className="sm:w-10 sm:h-10 md:w-12 md:h-12" />
              </button>
            </div>

            {/* RIGHT TEXT */}
            <div className="w-full sm:w-[45%] px-4 sm:px-8 py-3 sm:py-0 text-center sm:text-left">
              <h3 className="text-base sm:text-2xl md:text-4xl font-bold mb-2 sm:mb-5">
                {projectData[selectedProject].title}
              </h3>
              <p className="text-xs sm:text-base md:text-lg text-gray-200 leading-relaxed">
                {projectData[selectedProject].description}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
